(() => {
  if (window.__attariyeJudgeMePlacementInit) return;
  window.__attariyeJudgeMePlacementInit = true;

  const placeJudgeMe = () => {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    const productHeading = productInfo?.querySelector('.product__title > h1');
    const previewBadge = productInfo?.querySelector('.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge');

    if (productHeading && previewBadge && productHeading.nextElementSibling !== previewBadge) {
      productHeading.insertAdjacentElement('afterend', previewBadge);
    }

    const reviewWidget = document.querySelector('.jdgm-widget.jdgm-review-widget, .jdgm-review-widget');
    const reviewSection = reviewWidget?.closest('.shopify-section');
    const relatedSection = document.querySelector('[id^="shopify-section-"][id*="related-products"]');

    if (reviewSection && relatedSection && reviewSection.nextElementSibling !== relatedSection) {
      relatedSection.parentNode.insertBefore(reviewSection, relatedSection);
    }

    return Boolean(productHeading && previewBadge && reviewSection && relatedSection);
  };

  const start = () => {
    let attempts = 0;
    if (placeJudgeMe()) return;

    const timer = window.setInterval(() => {
      attempts += 1;
      if (placeJudgeMe() || attempts >= 40) window.clearInterval(timer);
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
